export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8322.10fc2e3d.jpg";